import { render, staticRenderFns } from "./indexRiesgoCardiovascular.vue?vue&type=template&id=06bc69fa"
import script from "./indexRiesgoCardiovascular.vue?vue&type=script&lang=js"
export * from "./indexRiesgoCardiovascular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports